import moment from 'moment';

export function getOrdinalSuffix(n) {
  if (n === 1) return 'st';
  if (n === 2) return 'nd';
  if (n === 3) return 'rd';
  return 'th';
}

export function generateSemesters(numberOfSemesters, oddSemesterDates, evenSemesterDates) {
  const semesters = [];
  for (let i = 1; i <= numberOfSemesters; i++) {
    const isOdd = i % 2 !== 0;
    semesters.push({
      semesterNumber: i,
      semesterName: `${i}${getOrdinalSuffix(i)} Semester`,
      semesterType: isOdd ? 'odd' : 'even',
      startDate: isOdd ? oddSemesterDates.startDate : evenSemesterDates.startDate,
      endDate: isOdd ? oddSemesterDates.endDate : evenSemesterDates.endDate,
    });
  }
  return semesters;
}

export const renderSemesterDetails = (academicYear) => {
  if (!academicYear.isSemesterBased) return null;

  return (
    <div className="mt-6">
      <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-6 border border-gray-200">
        <h4 className="text-lg font-semibold text-gray-900 mb-4">Semester Structure</h4>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {academicYear.oddSemesterDates && (
            <div className="bg-white rounded-lg p-4 border border-blue-200">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                <p className="text-sm font-semibold text-gray-700">Odd Semester Period</p>
              </div>
              <p className="text-sm text-gray-600">
                {moment(academicYear.oddSemesterDates.startDate).format('MMM DD, YYYY')} to {moment(academicYear.oddSemesterDates.endDate).format('MMM DD, YYYY')}
              </p>
            </div>
          )}
          {academicYear.evenSemesterDates && (
            <div className="bg-white rounded-lg p-4 border border-purple-200">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                <p className="text-sm font-semibold text-gray-700">Even Semester Period</p>
              </div>
              <p className="text-sm text-gray-600">
                {moment(academicYear.evenSemesterDates.startDate).format('MMM DD, YYYY')} to {moment(academicYear.evenSemesterDates.endDate).format('MMM DD, YYYY')}
              </p>
            </div>
          )}
        </div>

        {academicYear.semesters?.length > 0 && (
          <div>
            <h5 className="text-md font-semibold text-gray-700 mb-3">Semester Details</h5>
            <div className="overflow-hidden border border-gray-200 rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Semester</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Type</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">Start Date</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">End Date</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {academicYear.semesters.map((semester, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">{semester.semesterName}</td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          semester.semesterType === 'odd' 
                            ? 'bg-blue-100 text-blue-800' 
                            : 'bg-purple-100 text-purple-800'
                        }`}>
                          {semester.semesterType}
                        </span>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                        {moment(semester.startDate).format('MMM DD, YYYY')}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                        {moment(semester.endDate).format('MMM DD, YYYY')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export const extractDate = (dateObj) => {
  if (!dateObj) return '';
  if (typeof dateObj === 'string') return dateObj.slice(0, 10);
  if (dateObj.$date) return dateObj.$date.slice(0, 10);
  return '';
};